import { type FC } from 'react';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { DrawButtonContainer, GeoLocationContainer, ZoomInContainer, ZoomOutContainer } from '../MapControls';

import { MapControlsSlots } from './MapControlsSlots';

export const MapControlsSlotsContainer: FC = () => {
  const isMapOpen = useListingLayoutIsNarrowSelector();

  if (!isMapOpen) {
    return null;
  }

  return (
    <MapControlsSlots
      rightControls={
        <>
          <ZoomInContainer />
          <ZoomOutContainer />
          <GeoLocationContainer />
        </>
      }
      topControls={<DrawButtonContainer />}
    />
  );
};
